import { campaignConfig } from "./campaign-config";
import { initCampaign } from "./app/campaign";
import { createMediaCoordinator } from "./app/media-coordinator";
import { initFaq } from "./features/faq";
import { initJingle } from "./features/jingle";
import { initNewsletterDialog } from "./features/newsletter-dialog";
import { initRevealAnimations } from "./features/reveal-on-view";
import { initSiteHeader } from "./features/site-header";
import { initVideoHero } from "./features/video-hero";
import { initVillancicos } from "./features/villancicos";

export function initLanding(config = campaignConfig) {
  const mediaCoordinator = createMediaCoordinator();
  initCampaign(config);
  initRevealAnimations();
  initFaq();
  initNewsletterDialog(config);
  initJingle(config.jingle, config.activePhase, mediaCoordinator);
  initVideoHero(config.youtube?.header);
  initVillancicos({
    stories: config.youtube?.stories,
    villancicos: config.youtube?.slider,
  }, mediaCoordinator);
  initSiteHeader();
}
